// Keep the admin permission picker independent of the lazy recovery API service.
export const PHONE_RECOVERY_PERMISSION = 'remitz:member:phone-recovery';
